import React, { useState, useContext } from "react";
import { GlobalContext } from "../context/GlobalContext";
import { provinces, states } from "../constants";

const LocationForm = () => {
  const { address, updateAddress, toggleAddressForm } =
    useContext(GlobalContext);

  const [tempAddress, setTempAddress] = useState(address);
  const [provinceLabel, setProvinceLabel] = useState(
    address.country === "USA" ? "State" : "Province"
  );
  const [fullAddress, setFullAddress] = useState("");

  const handleBack = (e) => {
    e.preventDefault();
    toggleAddressForm();
  };

  const handleSave = (e) => {
    e.preventDefault();
    updateAddress({ address: tempAddress });
  };

  const handleCountryChange = (e) => {
    const country = e.target.value;

    setTempAddress({
      ...tempAddress,
      country,
      province: "",
      city: "",
      postalCode: "",
      address1: "",
    });

    setProvinceLabel(country === "USA" ? "State" : "Province");
  };

  const normalizeProvince = (addressInfo) => {
    if (addressInfo.state_code) {
      return addressInfo.state_code.toUpperCase();
    }

    if (addressInfo.state) {
      const match = provinces.find((p) =>
        addressInfo.state.toLowerCase().includes(p.toLowerCase())
      );

      if (match) {
        return match.slice(0, 2).toUpperCase();
      }
    }

    return "";
  };

  const handleEnterAdvance = (e) => {
    if (e.key.toLowerCase() === "enter") {
      const form = e.target.form;
      const index = [...form].indexOf(e.target);

      form.elements[index + 1]?.focus();
      e.preventDefault();
    }
  };

  const provinceOptions = (tempAddress.country === "USA" ? states : provinces).map(
    (option, idx) => (
      <option key={idx} value={option.slice(0, 2)}>
        {option}
      </option>
    )
  );

  const handleFullAddressChange = async (e) => {
    const value = e.target.value;
    setFullAddress(value);

    if (value.length < 5) return;

    const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${encodeURIComponent(
      value
    )}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (!data || data.length === 0) return;

      const addressInfo = data[0].address;

      const detectedCountry =
        addressInfo.country === "United States" ? "USA" : addressInfo.country;

      setTempAddress({
        address1: `${addressInfo.house_number || ""} ${
          addressInfo.road || ""
        }`.trim(),
        city:
          addressInfo.city ||
          addressInfo.town ||
          addressInfo.village ||
          "",
        province: normalizeProvince(addressInfo),
        postalCode: addressInfo.postcode || "",
        country: detectedCountry || "Canada",
      });

      setProvinceLabel(
        addressInfo.country === "United States" ? "State" : "Province"
      );
    } catch (error) {
      console.error("Address lookup error:", error);
    }
  };

  return (
    <form className="gog-search-form">
      <div className="gog-inline-form-row gog-field">
        <label>Full Address</label>

        <input
          type="text"
          value={fullAddress}
          onChange={handleFullAddressChange}
          placeholder="123 Main St, Toronto ON"
        />
      </div>

      <div className="gog-inline-form-row gog-field">
        <label>Country</label>

        <select
          value={tempAddress.country}
          onChange={handleCountryChange}
          onKeyDown={handleEnterAdvance}
        >
          <option value="Canada">Canada</option>
          <option value="USA">USA</option>
        </select>
      </div>

      <div className="gog-inline-form-row gog-field">
        <label>{provinceLabel}</label>

        <select
          value={tempAddress.province}
          onChange={(e) =>
            setTempAddress({ ...tempAddress, province: e.target.value })
          }
          onKeyDown={handleEnterAdvance}
        >
          <option value="">Select {provinceLabel}</option>
          {provinceOptions}
        </select>
      </div>

      <div className="gog-inline-form-row gog-field">
        <label>City</label>

        <input
          type="text"
          value={tempAddress.city}
          onChange={(e) =>
            setTempAddress({ ...tempAddress, city: e.target.value })
          }
        />
      </div>

      <div className="gog-inline-form-row gog-field">
        <label>Postal Code</label>

        <input
          type="text"
          value={tempAddress.postalCode}
          onChange={(e) =>
            setTempAddress({ ...tempAddress, postalCode: e.target.value })
          }
        />
      </div>

      <div className="gog-form-actions">
        <button type="button" onClick={handleBack} className="gog-light-btn">
          Back
        </button>

        <button type="button" onClick={handleSave} className="gog-primary-btn">
          Save
        </button>
      </div>
    </form>
  );
};

export default LocationForm;